import { toOption3 } from '@client/new/helpers/types';
import { BundleItem, BundleItemType, GetOfferQuery } from 'generated/graphql';
import { isNumber, isString } from '../../utils';
import { OfferDetailsData } from '@client/pages/CustomProgramPage/OfferDetails.mappers';

export const toOfferData = (data: GetOfferQuery): OfferDetailsData => {
  const onItems = (v: BundleItemType, f: keyof BundleItem) =>
    data.bundleById.items
      .filter((item) => item.itemType === v)
      .map((v) => v[f]);

  const programIds = onItems(BundleItemType.Program, 'itemId').filter(isNumber);
  const programs = data.creator.programs
    .filter((v) => programIds.includes(v.id))
    .map(toOption3('id', 'name'));

  const contentIds = onItems(BundleItemType.Content, 'contentId').filter(
    isString,
  );
  const contentItems = data.content.contentItems
    .filter((v) => contentIds.includes(v.value.id))
    .map((item) => ({
      value: item.value.id,
      label: (item.value as { title?: string }).title || '',
    }));

  const featureIds = onItems(BundleItemType.Feature, 'itemId').filter(isNumber);
  const features = data.feature
    .filter((v) => featureIds.includes(v.id))
    .map(toOption3('code', 'name'));

  return {
    programIds: { options: programs },
    extrasIds: { options: contentItems },
    communityFeatures: { options: features },
    price: data.bundleById.oneTimeProduct?.price ?? null,
    checkoutUrl: data.bundleById.checkoutPage?.url ?? null,
  };
};
